import React from 'react';
import BackgroundWrapper from '../Reusable/BackgroundWrapper';
import { motion } from 'framer-motion';

const TestimonialCard = ({ name, text }) => {
  return (
    <div className="relative bg-black/80 text-white p-6 overflow-hidden border border-red-600/40 h-full">
      {/* Red corner border */}
      <div className="absolute inset-0 pointer-events-none">
        <span className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-red-600" />
        <span className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-red-600" />
        <span className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-red-600" />
        <span className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-red-600" />
      </div>

      <h3 className="text-lg font-semibold mb-3">{name}</h3>

      <p className="text-sm text-white/60 leading-relaxed mb-6">{text}</p>

      {/* Stars */}
      <div className="flex gap-2">
        {[...Array(5)].map((_, i) => (
          <span key={i} className="text-white text-xl">
            ★
          </span>
        ))}
      </div>
    </div>
  );
};

const HorizontalMarquee = ({ items }) => {
  return (
    <div className="relative w-full overflow-hidden">
      {/* Left Fade */}
      <div className="pointer-events-none absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-black to-transparent z-10" />

      {/* Right Fade */}
      <div className="pointer-events-none absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-black to-transparent z-10" />

      <motion.div
        className="flex gap-8 w-max"
        animate={{ x: ['0%', '-50%'] }}
        transition={{
          duration: 25,
          ease: 'linear',
          repeat: Infinity,
        }}
      >
        {[...items, ...items].map((item, i) => (
          <div key={i} className="w-[420px] shrink-0">
            <TestimonialCard {...item} />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

const testimonials = [
  {
    name: 'Raghava Projects',
    text: 'Spatial Grid turned our print & digital ads into interactive AR experiences, helping buyers visualize our projects instantly and boosting both qualified enquiries and site visits.',
  },
  {
    name: 'Medha Servo',
    text: 'SpatialGrid’s platform and expertise accelerated our simulator development, elevated quality, and set new benchmarks. Their mastery of complex requirements, advanced technologies, and timely delivery ensures continued partnership built on innovation.',
  },
  {
    name: 'RLS',
    text: 'Spatial Grid’s VR training significantly improved safety awareness and SOP adherence among our plant operators through immersive, hands-on simulations.',
  },
];

const Testimonials = () => {
  return (
    <div className="bg-black  py-20">
      {/* Heading */}
      <div className="max-w-5xl text-center mx-auto space-y-4 pb-16">
        <h1 className="text-3xl md:text-5xl font-telegraf font-medium text-white">
          Testimonials
        </h1>

        <p className="text-[#bbbbbb] max-w-4xl mx-auto">
          Trusted by industry leaders, our immersive solutions deliver
          measurable impact — from safer training environments to higher
          engagement and faster decision-making.
        </p>
      </div>

      {/* Horizontal Marquee */}
      <div className="max-w-7xl mx-auto px-6">
        <HorizontalMarquee items={testimonials} />
      </div>
    </div>
  );
};

export default Testimonials;
